// extracted by mini-css-extract-plugin
export default {"contactSection":"yFdwYAIHjk7tfikL1dgJ"};